<div class="timeline-container">
  <div class="card-time">
    <h4 *ngIf="timeline.seqTimeline">
      {{ timeline.dataHora | date : 'HH:mm' }}
      <small>{{ timeline.dataHora | date : 'dd/MM/yyyy' }}</small>
    </h4>
  </div>

  <div class="card-dot">
    <span class="fa fa-circle"></span>
  </div>

  <div class="panel card-panel">
    <div class="step">
      <div class="content">
        <span class="icon"></span>
        <h2>{{ timeline.tituloStatus }}</h2>
        <span>{{ timeline.subTituloStatus }}</span>
      </div>

      <div *ngIf="timeline.finalizado" class="complemento">
        <div class="row" *ngIf="timeline.informacaoComplementar">
          <div class="col-xs-12">
            <div class="p descricao-complemento">
              {{ timeline.informacaoComplementar?.descricao }}
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!timeline.finalizado" class="complemento blue">
        <div class="row">
          <div class="col-xs-12 title border-top">
            O Cliente é Alfabetizado?
          </div>
        </div>
        <div class="row bg-white">
          <div class="col-xs-6">
            <app-switch
              id="alfabetizado"
              (change)="verificarMudancaTipo($event)"
              [(ngModel)]="alfabetizado"
              label="Alfabetizado"
              [disabled]="assinado"
            ></app-switch>
          </div>
          <div class="col-xs-6">
            <app-switch
              id="analfabeto"
              (change)="verificarMudancaTipo($event)"
              [(ngModel)]="analfabeto"
              label="Não Alfabetizado"
              [disabled]="assinado"
            ></app-switch>
          </div>
        </div>
        <div class="row" *ngIf="!bloqueiaAssinaturaDigital">
          <div
            (click)="toggleAssinatura = !toggleAssinatura"
            class="col-xs-12 title border-top border-bottom toggle"
            [ngClass]="{ up: toggleAssinatura }"
          >
            Opções de Assinatura
          </div>
        </div>
        <div *ngIf="toggleAssinatura" class="row bg-white border-bottom">
          <div class="col-xs-6">
            <app-switch
              id="assinaturaDigital"
              (change)="verificarMudancaTipo($event)"
              [(ngModel)]="assinaturaDigital"
              label="Assinatura Eletrônica"
              [disabled]="analfabeto || assinado"
            ></app-switch>
          </div>
          <div class="col-xs-6">
            <app-switch
              id="assinaturaManual"
              (change)="verificarMudancaTipo($event)"
              [(ngModel)]="assinaturaManual"
              label="Assinatura Manual"
              [disabled]="analfabeto || assinado"
            ></app-switch>
          </div>
          <ng-container *ngIf="!existeFotoDoCliente">
            Por segurança, precisamos de mais uma selfie do cliente.
            <app-webcam
              [isEnabledFotoAndEnviar]="true"
              [proposta]="proposta"
              [showSaveButton]="true"
              (selfieSaved)="updateFotoCliente($event)"
            ></app-webcam>
          </ng-container>
        </div>

        <div class="row">
          <div
            class="col-xs-12"
            *ngIf="timeline.informacaoComplementar?.descricao"
          >
            <div class="p descricao-complemento">
              {{ timeline.informacaoComplementar?.descricao }}
            </div>
          </div>

          <div
            *ngIf="timeline.informacaoComplementar?.documentosPendentes"
            class="col-xs-12"
          >
            <app-upload-arquivos
              buttonLabel="Enviar para formalização"
              hideInfo="true"
              [origem]="6"
              [isOrigemSos]="false"
              [hideSendButton]="
                assinaturaDigital &&
                !timeline.informacaoComplementar?.assinadoDigitalmente
              "
              [enableSendButton]="
                assinaturaDigital &&
                timeline.informacaoComplementar?.assinadoDigitalmente
              "
              [documentos]="documentosPendentes"
              [idFicha]="proposta.id"
              [cliente]="proposta.cliente"
              [acceptFiles]="acceptFiles"
              [isDisable]="!existeFotoDoCliente"
              (pushDocumentacao)="pushDocumentacao()"
            >
              <button
                *ngIf="
                  assinaturaDigital &&
                  !timeline.informacaoComplementar?.assinadoDigitalmente
                "
                class="btn btn-full-orange mb15"
                [disabled]="!existeFotoDoCliente"
                (click)="abrirModalAssinatura()"
              >
                Assinar Documentos
              </button>
            </app-upload-arquivos>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
